const REGULAR = {id: 1, title: 'Fix', short: 'Fix'}
const HOURLY = {id: 2, title: 'Hourly Rate', short: 'Hrs'}
const SIDE_HOURLY = {id: 3, title: 'Subproject', short: 'Sub'}

const projectTypes = [REGULAR, HOURLY]

export default projectTypes
export {REGULAR, HOURLY, SIDE_HOURLY}



// WEBPACK FOOTER //
// ./src/constants/projectTypes.js